import type { loader } from './FormsDrilldown.data.ts';

import * as React from 'react';
import { useLoaderData, useSearchParams } from 'react-router';

import { FiltersPanel } from '#components/FiltersPanel/FiltersPanel.tsx';
import { AssessmentType } from '#routes/Home/Filters/AssessmentType.tsx';
import { DateRange } from '#routes/Home/Filters/DateRange.tsx';
import { FormPriority } from '#routes/Home/Filters/FormPriority.tsx';
import { Provider } from '#routes/Home/Filters/Provider.tsx';
import { setProviderFilterSearchParams } from '#routes/Home/Filters/Provider.utils.ts';
import { allProvidersToken } from '#utils/provider-filter.ts';

export function FormsFiltersPanel() {
  const data = useLoaderData<Awaited<ReturnType<typeof loader>>>();
  const [, setSearchParams] = useSearchParams();
  const [resetKey, setResetKey] = React.useState(0);

  function handleRemoveAll() {
    setSearchParams((sp) => {
      // Only remove filters used in Forms panel
      sp.delete('view'); // Active view
      sp.delete('dp'); // Date preset
      sp.delete('from'); // Date range start
      sp.delete('to'); // Date range end
      sp.delete('astId'); // Assessment Type IDs
      sp.delete('fp'); // Forms Priority
      setProviderFilterSearchParams(sp, allProvidersToken);

      // Reset to first page after removing filters
      sp.set('page', '1');
      return sp;
    });

    // Delay reset key increment to ensure URL has updated
    setTimeout(() => {
      setResetKey((prev) => prev + 1);
    }, 0);
  }

  return (
    <FiltersPanel onRemoveAll={handleRemoveAll} gap={2}>
      <DateRange key={`date-${resetKey}`} defaultValue={[data.from, data.to]} />
      <Provider key={`provider-${resetKey}`} defaultValue={data.providerIds} />
      <AssessmentType key={`assessment-${resetKey}`} defaultValue={data.assessmentTypeIds} />
      <FormPriority key={`priority-${resetKey}`} defaultValue={data.formsPriority} />
    </FiltersPanel>
  );
}
